import React from 'react'
import { Button, TableCell, MenuItem } from '@material-ui/core'
import { EditableTextField, EditableSwitch, EditableSelect } from '../common/EditableComponents'
import {
  biotrackEnvironmentOptions as environmentOptions,
  biotrackModeOptions,
} from '../../utils/constants'
import { onChangeEditHOF } from '../../utils/common'
import EditActionComponent from '../common/EditActionComponent'

export default class BiotrackNewItem extends React.Component {
  onChange = onChangeEditHOF(this.props.onChange)

  onCancel = () => {
    this.props.onCancel()
    this.props.disableEdit()
  }

  onAddNewLocation = () => {
    this.props.onAddNewLocation(this.props.data)
    this.props.disableEdit()
  }
  render() {
    const { data, editMode, enableEdit } = this.props

    const onEditingCells = (
      <React.Fragment>
        <TableCell className="cell-wrap-word">
          <EditableSelect
            valueToRender={data.mode}
            editMode={editMode}
            value={data.mode}
            onChange={this.onChange('mode')}
          >
            {biotrackModeOptions.map((env) => {
              return <MenuItem value={env.value}>{env.label}</MenuItem>
            })}
          </EditableSelect>
        </TableCell>
        <TableCell className="cell-wrap-word">
          <EditableSelect
            valueToRender={data.environment}
            editMode={editMode}
            value={data.environment}
            onChange={this.onChange('environment')}
          >
            {environmentOptions.map((env) => {
              return <MenuItem value={env.value}>{env.label}</MenuItem>
            })}
          </EditableSelect>
        </TableCell>
        <TableCell className="cell-wrap-word">
          <EditableTextField
            valueToRender={data.locationLicense}
            editMode={editMode}
            value={data.locationLicense}
            onChange={this.onChange('locationLicense')}
            type="text"
            InputLabelProps={{
              shrink: true,
            }}
          />
        </TableCell>
        <TableCell className="cell-wrap-word">
          <EditableTextField
            valueToRender={data.licenseUBI}
            editMode={editMode}
            value={data.licenseUBI}
            onChange={this.onChange('licenseUBI')}
            type="text"
            InputLabelProps={{
              shrink: true,
            }}
          />
        </TableCell>
        <TableCell>
          <EditableTextField
            valueToRender={data.userName}
            editMode={editMode}
            value={data.userName}
            onChange={this.onChange('userName')}
            type="text"
            InputLabelProps={{
              shrink: true,
            }}
          />
        </TableCell>
        <TableCell>
          <EditableTextField
            valueToRender={editMode ? data.password : '****'}
            editMode={editMode}
            value={data.password}
            onChange={this.onChange('password')}
            type="text"
            InputLabelProps={{
              shrink: true,
            }}
          />
        </TableCell>
        <TableCell>
          <EditableSwitch
            valueToRender={data.enabled ? 'Enabled' : 'Disabled'}
            checked={data.enabled}
            editMode={editMode}
            onChange={this.onChange('enabled', true)}
          />
        </TableCell>
        <TableCell className="cell-wrap-word">
          <EditableSwitch
            valueToRender={data.enableSync ? 'Enabled' : 'Disabled'}
            checked={data.enableSync}
            editMode={editMode}
            onChange={this.onChange('enableSync', true)}
          />
        </TableCell>
        <TableCell>
          <EditActionComponent
            onSave={this.onAddNewLocation}
            onCancel={this.onCancel}
            onEdit={this.props.enableEdit}
            editMode={editMode}
          />
        </TableCell>
      </React.Fragment>
    )

    return (
      <React.Fragment>
        {editMode ? (
          onEditingCells
        ) : (
          <TableCell>
            <Button outlined="contained" color="primary" onClick={enableEdit}>
              Add
            </Button>
          </TableCell>
        )}
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Compliance/BiotrackNewItem.js